import React, { useEffect, useRef, useState } from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { useDispatch, useSelector } from "react-redux"
import { clearAnchorAll, updateAnchorListItem } from "../../../../entities/anchorListitem/anchorListItem.actions"
import { gtagger } from "../../../../helper/gtag"
import { usePrevious } from "../../../../hooks"
import { isDomAvailable } from "../../../../lib"
import { useDetectDevice } from "../../../../lib/useDetectDevice"
import { useBreadcrumbsBox } from "../../../common/Breadcrumbs"
import { Filters } from "../../../common/Filters"
import { Layout, WrapperMainComponent } from "../../../common/Layout"
import { ProductListItem } from "../../../common/ProductListItem"
import { ProductsCollectionLink } from "../../../common/ProductsCollectionLink"
import { ProductsDescription, ProductsDescriptionSEO } from "../../../common/ProductsDescription"
import { ProductsFaq } from "../../../common/ProductsFaq"
import { SEO } from "../../../common/SEO"
import {
  ItemWrapper,
  Text,
  Padding,
  InfiniteScrollDiv,
  FooterWrapper,
  LoadMoreBTn,
  PinInfoWrapper,
} from "./Products.style"

interface Props {
  className?: string
  products?: any
  loading?: boolean
  totalCount: number
  onLoadMore: () => void
  onClearFilter: Function
  error?: any
  filters: any[]
  onFiltersChange: Function
  categoryName?: string
  description: string
  contenuSEO: string
  liens_haut_page: string
  liens_bas_page: string
  faq: { question: string; reponse: string }
  seoTitle: string
  seoDescription: string
  titre_lien_bas_page: string
  category: {}
}

function ProductsViewCore({
  products = [],
  onFiltersChange,
  loading = true,
  error,
  totalCount,
  onLoadMore,
  onClearFilter,
  filters,
  className,
  categoryName = "Nos Produits",
  description,
  contenuSEO,
  liens_haut_page,
  liens_bas_page,
  faq,
  seoTitle,
  seoDescription,
  titre_lien_bas_page,
  category,
}: Props) {
  if (!seoTitle) {
    seoTitle =
      categoryName == "Nouveautés" || categoryName == "Promotions"
        ? "Découvrez nos " + categoryName + " "
        : categoryName + " dans les Plus Grandes Marques de Luxe"
  }

  if (!seoDescription) {
    seoDescription =
      "Retrouvez tous les produits " +
      categoryName +
      ". Grandes-Marques.fr vous propose le meilleur des grandes marques françaises et européennes de décoration et de linge de maison pour votre intérieur. Découvrez l’art de vivre à la Française."
  }

  const [dataLength, setDataLength] = useState(products.length)
  const [hasMore, setHasmore] = useState(
    totalCount > dataLength
  )
  const [BreadcrumbsBox, NavigateBackButton] = useBreadcrumbsBox({ "category": category, "productName": categoryName })

  useEffect(() => {
    setDataLength(products.length)
    setHasmore(totalCount > products.length)
  }, [products, totalCount])
  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} forceNoIndex={true} />

      {error && <div>Erreur lors du chargement des produits</div>}
      {/* <Wrapper className={className}> */}
      <BreadcrumbsBox />
      <WrapperMainComponent>
        <ProductsDescription data={description} />
        <ProductsCollectionLink data={liens_haut_page} />
      </WrapperMainComponent>
      {filters && (
        <Filters
          filters={filters}
          onFiltersChange={onFiltersChange}
          onClearFilter={onClearFilter}
        />
      )}
      <WrapperMainComponent>
        <DisplayProduct
          loading={loading}
          dataLength={dataLength}
          onLoadMore={onLoadMore}
          hasMore={hasMore}
          products={products}
        ></DisplayProduct>

        <PinInfoContainer
          loading={loading}
          productslength={products.length}
          totalCount={totalCount}
        ></PinInfoContainer>
        {!loading && (
          <FooterContainer
            productslength={products.length}
            totalCount={totalCount}
            onLoadMore={onLoadMore}
          />
        )}
        <NavigateBackButton />
        <ProductsCollectionLink data={liens_bas_page} ><h1>{titre_lien_bas_page}</h1></ProductsCollectionLink>
      </WrapperMainComponent>
      <ProductsDescriptionSEO data={contenuSEO} />
      {/* </WrapperDescription> */}
      <WrapperMainComponent>
        <ProductsFaq data={faq} />
      </WrapperMainComponent>
    </Layout >
  )
}

const PinInfoContainer = ({ loading, productslength, totalCount }) => {
  const [visible, setVisible] = useState(true)
  const prevIsLoading = usePrevious(loading)
  const timer = useRef(0)

  useEffect(() => {
    if (loading == false && prevIsLoading == true) {
      setVisible(true)
    }
  }, [loading])
  useEffect(() => {
    if (visible && isDomAvailable()) {
      window.clearTimeout(timer.current)
      timer.current = window.setTimeout(() => {
        setVisible(false)
      }, 1500)
    }
    return function cleanup() {
      isDomAvailable() && window.clearTimeout(timer.current)
    }
  }, [visible])

  if (productslength < totalCount) {
    return (
      <PinInfoWrapper isVisible={visible}>
        {productslength} produits chargés sur {totalCount}
      </PinInfoWrapper>
    )
  }
  return <></>
}

const FooterContainer = ({ productslength, totalCount, onLoadMore }) => {
  const dispatch = useDispatch()
  // pour eviter le bug d'affichage de produit > au max de produits
  function printMaxItemNumber(): string {
    let result = 0
    if (totalCount >= productslength) result = totalCount
    else result = productslength

    return result.toString() || ""
  }
  const loadMoreHandler = () => {
    dispatch(clearAnchorAll())
    onLoadMore()
  }
  const maxCurrent = Number(printMaxItemNumber())

  if (totalCount == 0 && !productslength) {
    gtagger("products", { value: "Pas de produit disponible" })
    return (
      <FooterWrapper>
        <Text>Pas de produit disponible</Text>
      </FooterWrapper>
    )
  }

  // HACK: regler le bug des produit qui se cahrge pas 
  useEffect(() => {
    if (maxCurrent > 0 && productslength == 0) loadMoreHandler()
  }, [maxCurrent, productslength])

  return (
    <FooterWrapper>
      <Text>
        {productslength} produits chargés sur {maxCurrent}
      </Text>
      {productslength != maxCurrent && (
        <LoadMoreBTn onClick={loadMoreHandler}>Suivant</LoadMoreBTn>
      )}
    </FooterWrapper>
  )
}

const WrapperClick = ({ children, numberOfItems }) => {
  const dispatch = useDispatch()
  const { after, products, url } = useSelector(state => state.anchorListItemReducer)
  const onClick = () => {

    dispatch(
      updateAnchorListItem(
        after,
        numberOfItems || 0,
        products,
        window.location.href
      )
    )
  }
  return (<div onClick={onClick}>{children}</div>)
}


export const ProductsView = React.memo(ProductsViewCore, (prevProps, nextProps) => {
  return (prevProps.products == nextProps.products) && (!nextProps.loading) && (prevProps.totalCount == nextProps.totalCount)
})




const DisplayProduct = React.memo(props => {
  const isMobile = useDetectDevice()

  const InfinitScrollWait = () => <div></div>

  // "&.mobile": {
  //   gridTemplateColumns: "1fr",
  //   marginTop: "60px"
  // }

  return (

    <InfiniteScrollDiv id="scrollableDiv">
      <InfiniteScroll
        dataLength={props.dataLength}
        next={props.onLoadMore}
        hasMore={props.hasMore}
        scrollThreshold="75%"
        loader={<InfinitScrollWait />}
        style={{
          width: " 100%",
          height: "auto",
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr 1fr",
          gridGap: "1em",
          gridTemplateRows: "repeat(1, 1fr)",
          maxWidth: "100em",
        }}
        endMessage={
          <p style={{ textAlign: 'center' }}>
            { }
          </p>
        }
      >

        {props.products.map((product, index) => {
          let [key, item] = product
          return (
            <div key={key}>
              <Card index={index} item={item} isMobile={isMobile} />
            </div>
          )
        })}
      </InfiniteScroll>
    </InfiniteScrollDiv >
  )
}, productsPropsAreEqual)


function productsPropsAreEqual(prev, next) {
  const numberOfProductFiff = prev.products?.length === next.products?.length

  return numberOfProductFiff;
}

const Card = React.memo(({ index, item, isMobile }) => {
  return (
    <WrapperClick numberOfItems={index} item={item}>
      <Padding className={isMobile && "mobile"} >
        <ItemWrapper className={isMobile && "mobile"}>
          <ProductListItem {...item} />
        </ItemWrapper>
      </Padding>
    </WrapperClick>
  )
}, cardPropsAreEqual)


function cardPropsAreEqual(prevCard, nextCard) {
  return prevCard.key === nextCard.key
}
